'use strict';

/* global Vue */

// Global variable for use within vnextCtrl.js
// - due to angular bootstrapping timing we need vue to init after angular
var coachingDrawer = {};

(function () {
  'use strict';

  coachingDrawer.coachingVueRoot = null;

  var profileElectionStatuses = {
    INELIGIBLE: 'INELIGIBLE',
    ELIGIBLE: 'ELIGIBLE',
    OFFERED: 'OFFERED',
    OPTED_IN: 'OPTED_IN',
    OPTED_OUT: 'OPTED_OUT'
  };

  // Init hook fired by angular controller
  coachingDrawer.init = function (userData, userCoachingProfile) {
    // NOSONAR
    var currentProfileElectionStatus = userCoachingProfile.coachingElection;
    var appDomain = null;

    // - This prevents code from running if Vue global is not set, like in angular focused unit test
    if (typeof Vue === 'undefined') {
      return;
    }

    // Note: Components must be registered before vue root init

    // Global vue filter(s)
    //
    Vue.filter('newlinetohtml', function (string) {
      return string.replace(/(?:\r\n|\r|\n)/g, '<br>');
    });

    // Re-creating the svg-icon directive for use in Vue
    // Global component registration
    Vue.component('svg-icon', {
      template: '<div class="svg-icon" v-html="svgHTML"></div>',
      props: ['iconId'],
      data: function data() {
        return {
          svgHTML: null
        };
      },
      mounted: function mounted() {
        var ngAppElem = angular.element(document.querySelector('[ng-app]') || document);
        var svgIcon = ngAppElem.injector().get('$templateCache').get(this.iconId + '.svg');

        if (svgIcon) {
          this.svgHTML = svgIcon;
        }
      }
    });

    var internalLinkDestinations = {
      inspiration: '/v/inspirations/detail/{{suffix:0}}',
      inspirations: {
        options: {
          new: '/v/inspirations/new',
          popular: '/v/inspirations',
          favorites: '/v/inspirations/my',
          me: '/v/inspirations/manage',
          upload: '/v/inspirations/upload'
        }
      },
      activity: '/v/activity/{{suffix:0}}/{{suffix:1}}',
      program: '/v/program/{{suffix:0}}',
      tools: {
        options: {
          index: '/v/tools',
          trackers: '/v/tracker/chart',
          goals: '/v/goals',
          sleep_plan: '/v/sleep/plan',
          sleep_diary: '/v/sleep/diary',
          sleep_entry: '/v/sleep/entry'
        }
      },
      search: {
        noSuffix: '/v/browse',
        suffix: '/v/browse/results/{{suffix:0}}'
      },
      history: {
        options: {
          activity: '/v/history',
          assessment: '/v/assessments'
        }
      },
      home: '/v/',
      contact: 'https://mystrength.com/contact',
      getHelp: '/v/help'
    };

    var coachingMessageInternalLink = {
      template: '#coach-message-internal-link-template',
      name: 'AttachmentInternalLink',
      props: {
        attachment: {
          type: Object,
          required: true
        }
      },
      computed: {
        fullLinkHref: function fullLinkHref() {
          var httpsRegex = new RegExp('^https:');
          if (httpsRegex.test(this.linkHref)) {
            return encodeURI(this.linkHref);
          } else {
            return appDomain + encodeURI(this.linkHref);
          }
        },
        internalLinkTitle: function internalLinkTitle() {
          if (this.attachment.attachmentMeta && this.attachment.attachmentMeta.translationKey) {
            var translationKey = 'vnext.coaching.internalLinks.' + this.attachment.attachmentMeta.translationKey;
            return this.translations[translationKey] || this.attachment.attachmentMeta.title || this.attachment.content;
          }
          return this.attachment.attachmentMeta && this.attachment.attachmentMeta.title ? this.attachment.attachmentMeta.title : this.attachment.content;
        }
      },
      data: function data() {
        return {
          linkHref: null,
          translations: {}
        };
      },

      methods: {
        registerAngularServices: function registerAngularServices() {
          // Get angular root instance & injector
          var elem = angular.element(document.querySelector('body'));
          var injector = elem.injector();

          this.$languageSvc = injector.get('languageSvc');
          var currentLanguageCode = this.$languageSvc.getLanguage() || 'en-US';
          this.$translate = injector.get('$translate');
          this.translations = this.$translate.getTranslationTable(currentLanguageCode);
        },
        buildInternalLinkHref: function buildInternalLinkHref() {
          var internalLinkArray = this.attachment.content.split(':');
          var linkBase = internalLinkArray[0];
          var linkSuffixes = internalLinkArray.slice(1);
          var destinationHasOptions = internalLinkDestinations[linkBase] && typeof internalLinkDestinations[linkBase]['options'] !== 'undefined';

          if (typeof internalLinkDestinations[linkBase] === 'undefined') {
            console.warn('Invalid internal link base: ' + linkBase);
            return;
          }

          if (destinationHasOptions) {
            this.buildLinkWithOptions(linkBase, linkSuffixes);
          } else if (linkBase === 'search') {
            this.buildSearchLink(linkBase, linkSuffixes);
          } else {
            this.buildPlainLink(linkBase, linkSuffixes);
          }
        },
        buildLinkWithOptions: function buildLinkWithOptions(linkBase, linkSuffixes) {
          if (linkBase === 'tools' && linkSuffixes[0] === 'sleep_entry') {
            var date = new Date();
            date.setDate(date.getDate() - 1);
            this.linkHref = internalLinkDestinations[linkBase]['options'][linkSuffixes[0]] + '?day=' + date.toISOString().split('T')[0];
          } else {
            this.linkHref = internalLinkDestinations[linkBase]['options'][linkSuffixes[0]];
          }
        },
        buildSearchLink: function buildSearchLink(linkBase, linkSuffixes) {
          if (linkSuffixes.length > 0) {
            this.linkHref = this.replaceUrlToken(internalLinkDestinations[linkBase]['suffix'], 'suffix:0', linkSuffixes[0]);
          } else {
            this.linkHref = internalLinkDestinations[linkBase]['noSuffix'];
          }
        },
        buildPlainLink: function buildPlainLink(linkBase, linkSuffixes) {
          var _this = this;

          var linkUrlTemplate = internalLinkDestinations[linkBase];

          if (!this.urlTemplateHasToken(linkUrlTemplate)) {
            this.linkHref = linkUrlTemplate;
          } else {
            this.linkHref = linkSuffixes.reduce(function (acc, suffix, index) {
              var token = 'suffix:' + index;
              return _this.replaceUrlToken(acc, token, suffix);
            }, linkUrlTemplate);
          }
        },
        replaceUrlToken: function replaceUrlToken(url, token, replacement) {
          return url.replace('{{' + token + '}}', replacement);
        },
        urlTemplateHasToken: function urlTemplateHasToken(url) {
          var tokenRegex = new RegExp('[{]{2}suffix:[0-9][}]{2}', 'gm');
          return tokenRegex.test(url);
        }
      },
      beforeMount: function beforeMount() {
        this.registerAngularServices();
      },
      mounted: function mounted() {
        this.buildInternalLinkHref();
      },
      updated: function updated() {
        this.buildInternalLinkHref();
      }
    };

    // Coaching message thread component
    var coachingMessageThread = {
      template: '#coach-message-thread-template',
      props: ['app-domain', 'active-coach', 'coach-profiles', 'coaching-messages', 'user-data', 'close-drawer'],
      data: function data() {
        return {
          httpSvc: null
        };
      },
      components: {
        'attachment-internal-link': coachingMessageInternalLink
      },
      methods: {
        registerAngularServices: function registerAngularServices() {
          // Get angular root instance & injector
          var elem = angular.element(document.querySelector('body'));
          var injector = elem.injector();

          // Set angular service methods for vue usage
          this.httpSvc = injector.get('httpSvc');
        },
        isCoachMessage: function isCoachMessage(messageData) {
          return messageData.type === 'FROM_COACH';
        },
        getHumanReadableMessageTimestamp: function getHumanReadableMessageTimestamp(unixTime) {
          return moment(unixTime).format('lll');
        },
        getDateTimeMessageTimestamp: function getDateTimeMessageTimestamp(unixTime) {
          return moment(unixTime).format('YYYY-MM-DD h:mm:ss A');
        },
        buildActivityURL: function buildActivityURL(activityString, attachmentType) {
          if (attachmentType === 'COMMUNITY_INSPIRATION' || attachmentType === 'CORE_INSPIRATION') {
            return this.appDomain + '/v/inspirations/detail/' + activityString;
          }

          return this.appDomain + '/v/activity/' + activityString + '/detail';
        },

        attachmentLinkClick: function attachmentLinkClick(activity) {
          if (activity.type === 'INTERNAL_LINK' || activity.type === 'ACTIVITY') {
            this.closeDrawer();
          }

          // Send ATTACHMENT_CLICKED coaching event
          this.httpSvc.post('/apiproxy/coaching/events', {
            eventType: 'ATTACHMENT_CLICKED',
            description: activity.id
          });
        },
        filterMessage: function filterMessage(message) {
          return Vue.options.filters.newlinetohtml(message);
        },
        underscoreToKebabCase: function underscoreToKebabCase(string) {
          return string.replace(/_/gim, '-');
        },
        messageTypeToClass: function messageTypeToClass(string) {
          if (!string) {
            return '';
          }
          return this.underscoreToKebabCase(string.toLowerCase());
        }
      },
      computed: {
        userInitials: function userInitials() {
          return this.userData.firstName[0] + ' ' + (this.userData.lastName ? this.userData.lastName[0] : '');
        }
      },
      mounted: function mounted() {
        this.registerAngularServices();
      }
    };

    // Coach drawer component
    var coachDrawer = {
      template: '#coach-drawer-template',
      components: {
        'coaching-message-thread': coachingMessageThread
      },
      props: ['app-domain', 'coach-drawer-shown', 'active-coach', 'coach-profiles', 'coaching-messages', 'user-data', 'show-initial-coaching-view', 'send-message-error'],
      data: function data() {
        return {
          coachingMessagesLoaded: false,
          showCoachBio: false,
          messageToCoach: '',
          messageToCoachValidationMessageKey: '',
          messageToCoachValidationMessageAlt: '',
          messageToCoachError: false,
          coachingMessageOverlayShown: false,
          translations: {},
          $timeout: null,
          currentLanguageCode: '',
          supportedLanguages: []
        };
      },
      computed: {
        coachCommunicationLanguages: function coachCommunicationLanguages() {
          var _this2 = this;

          if (this.activeCoach && this.activeCoach.properties) {
            var coachLanguages = this.activeCoach.properties.map(function (property) {
              var languageObj = _.find(_this2.supportedLanguages, { language: property.language });
              return languageObj ? _this2.getTranslationKey(languageObj) : null;
            }).filter(function (lang) {
              return lang;
            }).join(', ');
            return coachLanguages ? coachLanguages : 'English(United States)';
          } else {
            return '';
          }
        },
        coachBio: function coachBio() {
          this.currentLanguageCode = this.$languageSvc.getLanguage() || 'en-US';
          if (this.activeCoach && this.activeCoach.properties) {
            var currentBio = _.find(this.activeCoach.properties, { language: this.currentLanguageCode });
            return currentBio && currentBio.biography ? currentBio.biography : this.coachBioHelper();
          } else {
            return '';
          }
        }
      },
      methods: {
        getTranslationKey: function getTranslationKey(languageObj) {
          var languageCode = languageObj.language.replace('-', '');
          return this.$translate.instant('vnext.languages.' + languageCode) === 'vnext.languages.' + languageCode ? languageObj.name : this.$translate.instant('vnext.languages.' + languageCode);
        },
        coachBioHelper: function coachBioHelper() {
          var defaultLanguage = this.$languageSvc.getDefaultLanguage();
          var defaultBio = _.find(this.activeCoach.properties, { language: defaultLanguage });
          var fallBackBio = _.find(this.activeCoach.properties, { language: 'en-US' });

          if (defaultBio && defaultBio.biography) {
            return defaultBio.biography;
          } else if (fallBackBio && fallBackBio.biography) {
            return fallBackBio.biography;
          } else {
            return '';
          }
        },
        registerAngularServices: function registerAngularServices() {
          var elem = angular.element(document.querySelector('body'));
          var injector = elem.injector();
          this.$translate = injector.get('$translate');
          this.$timeout = injector.get('$timeout');
          this.$languageSvc = injector.get('languageSvc');
        },
        translateUI: function translateUI() {
          var _this3 = this;

          this.$timeout(function () {
            var currentLanguageCode = _this3.$languageSvc.getLanguage() || 'en-US';
            _this3.translations = _this3.$translate.getTranslationTable(currentLanguageCode);
          }, 1000);
        },
        sendMessageToCoach: function sendMessageToCoach() {
          var _this4 = this;

          if (this.messageToCoach.trim().length === 0) {
            // Basic validation - not empty
            this.messageToCoachValidationMessageKey = 'vnext.coaching.inputMessage';
            this.messageToCoachValidationMessageAlt = 'Please input a message to send to your coach.';
            this.messageToCoachError = true;
            return;
          } else if (this.stringContainsUrl(this.messageToCoach)) {
            // Message contains URL validation
            this.messageToCoachValidationMessageKey = 'vnext.coaching.doNotSendUrl';
            this.messageToCoachValidationMessageAlt = 'Please do not send your coach a URL in the message field.';
            this.messageToCoachError = true;
            return;
          }

          // Reset validation
          this.messageToCoachValidationMessageKey = '';
          this.messageToCoachValidationMessageAlt = '';
          this.messageToCoachError = false;

          // Event to coaching drawer root to send message
          this.$emit('send-message-to-coach', this.messageToCoach);
          this.messageToCoach = '';
          this.coachingMessageOverlayShown = true;

          setTimeout(function () {
            _this4.coachingMessageOverlayShown = false;
          }, 5000);
        },
        closeDrawer: function closeDrawer() {
          // Event to vue root for angular sync
          this.$emit('close-drawer');
        },
        stringContainsUrl: function stringContainsUrl(string) {
          // Regex sourced from https://mathiasbynens.be/demo/url-regex - @stephenhay
          var urlRegex = /(https?|ftp):\/\/[^\s/$.?#].[^\s]*/gi;
          return urlRegex.test(string);
        }
      },
      watch: {
        coachingMessages: function coachingMessages() {
          if (this.coachingMessages && this.coachingMessages.coachId) {
            this.coachingMessagesLoaded = true;
          }
        },
        sendMessageError: function sendMessageError(newValue) {
          // Reset message
          if (!newValue || newValue.length === 0) {
            this.messageToCoachValidationMessageKey = '';
            this.messageToCoachValidationMessageAlt = '';
            this.messageToCoachError = false;

            return;
          }

          this.messageToCoachValidationMessageKey = newValue.key;
          this.messageToCoachValidationMessageAlt = newValue.message;

          this.messageToCoachError = true;
        }
      },
      mounted: function mounted() {
        var _this5 = this;

        // Register angular services for vue usage
        this.registerAngularServices();
        this.translateUI();

        // Set supported languages
        this.$languageSvc.getSupportedLanguages().then(function (languages) {
          _this5.supportedLanguages = languages;
        });
      }
    };

    // Coaching drawer root vue component
    // Ideally all communication from vue to angular happens in this component
    // As well as any http requests
    coachingDrawer.coachingVueRoot = new Vue({
      el: '#vue-coaching-drawer-root',
      components: {
        'coach-drawer': coachDrawer
      },
      data: function data() {
        return {
          message: '!- Vue init -!',
          userData: userData,
          coachDrawerShown: false,
          requestToken: null,
          userCoachingProfileElection: currentProfileElectionStatus ? currentProfileElectionStatus : null,
          coachProfiles: null,
          coachingMessages: null,
          sendMessageError: '',
          appDomain: null,
          messagesMarkedAsRead: false,
          socket: null,
          messagePollDelay: 60000,
          messagePollInterval: null,
          // Angular services
          $cookies: null,
          httpSvc: null,
          $timeout: null,
          $domainSvc: null,
          $interval: null,
          focus: null
        };
      },
      computed: {
        activeCoach: function activeCoach() {
          if (!this.coachingMessages || !this.coachProfiles || Object.keys(this.coachProfiles).length < 1) {
            return {};
          }
          return this.coachProfiles[userData.coachingAssignment.currentCoachId];
        },
        isCoachingElectionEligible: function isCoachingElectionEligible() {
          return this.userCoachingProfileElection === profileElectionStatuses.ELIGIBLE;
        },
        isCoachingElectionOffered: function isCoachingElectionOffered() {
          return this.userCoachingProfileElection === profileElectionStatuses.OFFERED;
        }
      },
      methods: {
        registerAngularServices: function registerAngularServices() {
          // Get angular root instance & injector
          var elem = angular.element(document.querySelector('body'));
          var injector = elem.injector();

          // Set angular service methods for vue usage
          this.$cookies = injector.get('$cookies');
          this.httpSvc = injector.get('httpSvc');
          this.$timeout = injector.get('$timeout');
          this.$domainSvc = injector.get('domainSvc');
          this.$interval = injector.get('$interval');
          this.focus = injector.get('focus');
        },
        setRequestToken: function setRequestToken() {
          // Set request token for later use
          this.requestToken = this.$cookies.get('token');
        },
        initAngularToVueCommunication: function initAngularToVueCommunication() {
          var _this6 = this;

          // Angular -> Vue communication
          window.addEventListener('message', function (e) {
            var messageData = e.data;

            // Prevent actions on any messages not from angular
            if (messageData.origin !== 'angular') {
              return;
            }

            if (messageData.name === 'showCoaching') {
              // Update vue value
              _this6.coachDrawerShown = messageData.value;
            }
          }, false);
        },
        getCoachProfiles: function getCoachProfiles() {
          var _this7 = this;

          this.httpSvc.get('/apiproxy/coaching/coaches/profiles').then(function (resp) {
            // Convert array to coachId keyed object for easy use
            _this7.coachProfiles = resp.reduce(function (acc, item) {
              acc[item.id] = item;
              return acc;
            }, {});
          });
        },
        getCoachingMessages: function getCoachingMessages() {
          var _this8 = this;

          this.httpSvc.get('/apiproxy/coaching/messages').then(function (resp) {
            // Detect if we have new message in thread
            var hasNewMessage = _this8.detectNewMessage(resp);

            // Set data
            _this8.coachingMessages = resp;

            // Mark newly polled messages as read if drawer open
            if (hasNewMessage && _this8.coachDrawerShown) {
              _this8.messagesMarkedAsRead = false;
              _this8.markCoachMessagesAsRead();
            }

            // Test if user should be shown the coaching experience for the first time
            if (_this8.isCoachingElectionEligible) {
              // Show drawer after 1s
              _this8.$timeout(function () {
                // Send message to angular to display drawer
                window.postMessage({
                  name: 'showCoaching',
                  origin: 'vue',
                  value: true
                }, window.location.origin);
              }, 1000);
            }
          });
        },
        markCoachMessagesAsRead: function markCoachMessagesAsRead() {
          var _this9 = this;

          if (!this.coachingMessages || !this.coachingMessages.messages || this.coachingMessages.messages.length === 0) {
            return;
          }
          // Mark read for all messages with coachingMessages.messages[].readOn = null
          this.coachingMessages.messages.forEach(function (messageData) {
            // Only set status on messages FROM_COACH and where readOn is null
            if (messageData.type === 'FROM_COACH' && messageData.readOn === null && _this9.messagesMarkedAsRead === false) {
              _this9.httpSvc.post('/apiproxy/coaching/messages/read/' + messageData.id, {});
            }
          });
          this.messagesMarkedAsRead = true;
        },
        sendMessageToCoach: function sendMessageToCoach(messageToCoach) {
          var _this10 = this;

          this.sendMessageError = '';

          this.httpSvc.post('/apiproxy/coaching/messages', {
            message: messageToCoach,
            attachments: null
          }).then(function () {
            // Update coachingMessages after request has been completed
            _this10.getCoachingMessages();

            // Change election status since message has been sent
            // - This action happens server side on first user message send
            if (_this10.isCoachingElectionEligible || _this10.isCoachingElectionOffered) {
              _this10.userCoachingProfileElection = 'OPTED_IN';
              // Scroll to top
              _this10.$timeout(function () {
                document.querySelector('.coaching-drawer-wrapper').scrollTo({
                  top: 0,
                  behavior: 'smooth'
                });
              }, 50);
            }
          }, function (error) {
            if (error.data.message.includes('cannot contain URL')) {
              var message = 'Your message contains a URL and is unable to be sent. Please do not send URL\'s to your coach.';
              _this10.sendMessageError = { key: 'vnext.coaching.cannotContainUrl', message: message };
            } else {
              // Handle request error
              var _message = 'Your message was unable to be sent. Please reload the page and try again.';
              _this10.sendMessageError = { key: 'vnext.coaching.unableToSent', message: _message };
            }
          });
        },
        setCoachingElectionStatusOffered: function setCoachingElectionStatusOffered() {
          var _this11 = this;

          return this.httpSvc.post('/apiproxy/coaching/profile/coachingelection', {
            coachingElection: profileElectionStatuses.OFFERED
          }).then(function () {
            _this11.userCoachingProfileElection = profileElectionStatuses.OFFERED;
          });
        },
        closeDrawer: function closeDrawer() {
          // Vue -> Angular communication
          window.postMessage({
            name: 'showCoaching',
            origin: 'vue',
            value: false
          }, window.location.origin);
        },
        detectNewMessage: function detectNewMessage(responseData) {
          if (this.coachingMessages && responseData.messages.length > this.coachingMessages.messages.length) {
            // Mark message as read if coachDrawerShown
            if (this.coachDrawerShown) {
              this.markCoachMessagesAsRead();
            }
            // Vue -> Angular communication
            // Let angular know we have a new message
            // - Used to update the sidebar message count &
            // - mobile notification badge
            window.postMessage({
              name: 'newCoachingMessage',
              origin: 'vue',
              value: true
            }, window.location.origin);

            return true;
          }

          return false;
        },
        initChatWebsocket: function initChatWebsocket() {
          var _this12 = this;

          var hasWebsocketFeature = window.MYSTRENGTH.config.platforms.web.features.websockets === true;

          // If api doesn't enable websockets, use polling
          if (!hasWebsocketFeature) {
            // Poll for new messages from coach
            this.pollForNewMessages();

            return;
          }

          var urlPrefixRegex = new RegExp('^http(s?)', 'gm');
          var isHttps = new RegExp('^https:').test(window.MYSTRENGTH.API_URL);
          var websocketBaseUrl = window.MYSTRENGTH.API_URL.replace(urlPrefixRegex, isHttps ? 'wss' : 'ws');

          this.socket = new WebSocket(websocketBaseUrl + '/coaching/session');

          // Authenticate using token on open
          this.socket.addEventListener('open', function () {
            _this12.socket.send(JSON.stringify({
              token: _this12.requestToken
            }));
          });

          // Update thread on message from coach
          this.socket.addEventListener('message', function (event) {
            var data = JSON.parse(event.data);

            if (data.type !== 'TO_COACH') {
              _this12.getCoachingMessages();
            }
          });
        },
        pollForNewMessages: function pollForNewMessages() {
          var _this13 = this;

          if (this.messagePollInterval !== null) {
            return;
          }
          this.messagePollInterval = this.$interval(function () {
            _this13.getCoachingMessages();
          }, this.messagePollDelay);
        },
        clearMessagePollInterval: function clearMessagePollInterval() {
          if (this.messagePollInterval !== null) {
            return;
          }
          this.$timeout.cancel(this.messagePollInterval);
        }
      },
      watch: {
        coachDrawerShown: function coachDrawerShown(newValue) {
          // On drawer open - mark all unread messages as read
          if (newValue) {
            this.markCoachMessagesAsRead();
            this.focus.byId('coaching-title');
          } else {
            this.focus.byId('coach-badge');
          }

          // Set coaching profile election status OFFERED
          if (this.isCoachingElectionEligible) {
            this.setCoachingElectionStatusOffered();
          }
        }
      },
      mounted: function mounted() {
        // Setup angular -> vue communication
        this.initAngularToVueCommunication();

        // Register angular services for vue usage
        this.registerAngularServices();

        // Set request token for later use
        this.setRequestToken();

        // Get coach profiles for use with coaching messages
        this.getCoachProfiles();

        // Get users coaching messages
        this.getCoachingMessages();

        // Init websocket for real time message updates
        this.initChatWebsocket();

        // Set appDomain
        this.appDomain = this.$domainSvc.getAppDomain();
        appDomain = this.$domainSvc.getAppDomain();
      },
      beforeDestroy: function beforeDestroy() {
        this.clearMessagePollInterval();
      }
    });

    return coachingDrawer.coachingVueRoot;
  }; // coachingDrawer.init()
})();